import { BackBar, BillDetails } from '@horof/shared';
import { useParams } from 'react-router';

/** An invoice's details, opened from a meter or the month close. */
export function BillPage() {
  const { billId = '' } = useParams();
  return (
    <div className="page">
      <BackBar to="back" label="رجوع" />
      <BillDetails
        billId={billId}
        memberLink={(id) => `/members/${id}`}
        meterLink={(id) => `/meters/${id}`}
      />
    </div>
  );
}
